/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SmsModule
 */
export interface SmsModule {
    /**
     * 
     * @type {boolean}
     * @memberof SmsModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the SmsModule interface.
 */
export function instanceOfSmsModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SmsModuleFromJSON(json: any): SmsModule {
    return SmsModuleFromJSONTyped(json, false);
}

export function SmsModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function SmsModuleToJSON(value?: SmsModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

